module.exports = __webpack_public_path__ + "7205832172cccbc53e0a4ff23b15f9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logo.png
// module id = 205
// module chunks = 0